module.exports = __webpack_public_path__ + "static/media/02.d38213b8.png";